<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isNewEditVisible"
  (nzVisibleChange)="onIsNewEditVisibleChange($event)"
  [nzTitle]="isEdit ? 'Edit Product' : 'Add New Product'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="null"
  [nzCancelText]="null"
>
  <ng-container *nzModalContent>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="title">Title</nz-form-label>
        <nz-form-control nzErrorTip="Title required.">
          <div class="horizontal">
            <input nz-input formControlName="title" id="title" [placeholder]="'Your title'" />
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="description">Description</nz-form-label>
        <nz-form-control nzErrorTip="Product description required.">
          <textarea
            nz-input
            formControlName="description"
            rows="5"
            id="description"
            [placeholder]="'Your product.'"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button [nzType]="'primary'" class="submit-button">{{ isEdit ? 'Save' : 'Create' }}</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
